import { motion } from "framer-motion";
import { HeartPulse, Pill, Stethoscope, Cpu, Cog, Scale } from "lucide-react";

const SECTORS = [
  { icon: HeartPulse, name: "Healthcare", note: "Providers, distributors & care networks entering new regions." },
  { icon: Pill, name: "Pharmaceuticals", note: "Regulatory-aware sourcing, licensing and market access." },
  { icon: Stethoscope, name: "Medical Devices", note: "Connecting device makers with certified global buyers." },
  { icon: Cpu, name: "Technology", note: "Cross-border partnerships for digital products and services." },
  { icon: Cog, name: "Manufacturing", note: "Supplier discovery, capacity matching and export readiness." },
  { icon: Scale, name: "Professional Services", note: "Firms expanding their client base across jurisdictions." },
];

export const Sectors = () => (
  <section id="sectors" data-testid="sectors-section" className="relative overflow-hidden bg-royal-deep py-24 lg:py-32">
    <div className="pointer-events-none absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-2xl text-center"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold sm:text-xs">Sectors we serve</p>
        <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
          Where we create traction.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate-400">
          We facilitate cross-border collaboration across sectors where trust, compliance, and timing decide the deal.
        </p>
      </motion.div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SECTORS.map(({ icon: Icon, name, note }, i) => (
          <motion.div
            key={name}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`sector-card-${i + 1}`}
            className="group flex items-start gap-5 rounded-xl border border-white/10 bg-white/[0.02] p-7 transition-colors duration-500 hover:border-gold/50 hover:bg-gold/[0.04]"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gold/30 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-royal-deep">
              <Icon size={19} />
            </div>
            <div>
              <h3 className="font-serif text-lg font-semibold text-white">{name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{note}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
